import { createFileRoute } from '@tanstack/react-router';
import { RequireRole } from '../components/RequireRole';
import { InviteUser } from '../features/users/InviteUser';

export const Route = createFileRoute('/users/invite')({
  component: () => (
    <RequireRole allow={['admin', 'responsable_partenaire', 'responsable_backoffice', 'manager']}>
      <InviteUser />
    </RequireRole>
  ),
});
